import { render, staticRenderFns } from "./Form.Importador.vue?vue&type=template&id=60486486"
import script from "./Form.Importador.vue?vue&type=script&lang=js"
export * from "./Form.Importador.vue?vue&type=script&lang=js"
import style0 from "./Form.Importador.vue?vue&type=style&index=0&id=60486486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports